import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import { clientQueryKeys } from "./query-keys";

import { vacancyQueryKeys } from "@/features/vacancies/api/queryKeys";
import { instance } from "@/lib/axios/instance";
import { ClientTypeEnum } from "@/types/client/ClientType";
import { EditClientResponse } from "@/types/response/EditClientResponse";

type UpdateImportSourceRequest = {
  clientType?: ClientTypeEnum;
  recruitNowUrl?: string;
  recruitNowApiKey?: string;
  feedUrl?: string;
  feedFormat?: string;
  tenantId?: string | null;
};

export function useUpdateImportSourceMutation(
  clientId?: string,
  tenantId?: string | null
) {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponse<EditClientResponse>,
    AxiosError<{ title: string; detail: string; status?: number; field?: string }>,
    UpdateImportSourceRequest
  >({
    mutationFn: (request: UpdateImportSourceRequest) =>
      instance.put(`/api/v2/Clients/${clientId}/import-source`, {
        clientType: request.clientType,
        recruitNowUrl: request.recruitNowUrl,
        recruitNowApiKey: request.recruitNowApiKey,
        feedUrl: request.feedUrl,
        feedFormat: request.feedFormat,
        tenantId: request.tenantId || tenantId,
      }),
    onSuccess: () => {
      // Invalidate all client queries
      queryClient.invalidateQueries({
        queryKey: clientQueryKeys.all,
      });
      // Invalidate specific client detail if we have clientId
      if (clientId) {
        queryClient.invalidateQueries({
          queryKey: clientQueryKeys.detail(clientId),
        });
      }
      // Invalidate vacancies as they may depend on client data
      queryClient.invalidateQueries({
        queryKey: vacancyQueryKeys.all,
      });
    },
  });
}
